import { createRouter, createWebHistory } from 'vue-router'
import { notification } from 'ant-design-vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import systemRouter from './systemRouter'
import whiteListRouters from './whiteList'
import tool from '@/utils/tool'
import motorApi from '@/api/user/motorApi'
// 进度条配置
NProgress.configure({ showSpinner: false, speed: 500 })

// 系统特殊路由
const routes_404 = [
	{
		path: '/:pathMatch(.*)*',
		component: () => import('@/views/other/404.vue')
	},
	{
		path: '/coalesceteachers',
		component: () => import('@/views/other/coalesceteachers/index.vue'),
		meta: {
			title: '兼职教师库'
		}
	},
	{
		path: '/coalesceteachersSuccess',
		component: () => import('@/views/other/coalesceteachers/success.vue'),
		meta: {
			title: '兼职教师库'
		}
	},
]
// 系统路由
const routes = [...systemRouter, ...whiteListRouters, ...routes_404]

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior() {
		// 页面跳转之后始终滚动到顶部
		return { top: 0 }
	},
})

// 判断是否已加载过动态/静态路由
const isGetRouter = ref(false)

// 白名单校验
const exportWhiteListFromRouter = (router) => {
	const res = []
	for (const item of router) res.push(item.path)
	return res
}
const whiteList = exportWhiteListFromRouter(whiteListRouters)

router.beforeEach(async (to, from, next) => {
	NProgress.start()
	// 上报用户访问记录
	motorApi.pvAdd({
		device: 'PC'
	})
	// 动态标题
	document.title = to.meta.title ? `${to.meta.title} - ${import.meta.env.VITE_TITLE}` : import.meta.env.VITE_TITLE

	// 过滤白名单
	if (whiteList.includes(to.path)) {
		next()
		return false
	}

	const token = tool.session.get('TOKEN')
	if (to.path === '/login' || to.path === '/wxMpLogin') {
		// 当用户输入了login路由，将其跳转首页即可
		if (token) {
			next({
				path: '/'
			})
			return false
		}
		isGetRouter.value = false
		next()
		return false
	} else {
		// 这里需要使用 localStorage 保存登录之前要访问的页面
		tool.data.set('LAST_VIEWS_PATH', to.fullPath)
	}
	if (!token && (to.path !== '/coalesceteachers' && to.path !== '/coalesceteachersSuccess')) {
		next({
			path: '/home'
		})
		return false
	}
	// 加载动态/静态路由
	if (!isGetRouter.value) {
		isGetRouter.value = true
		next({ ...to, replace: true })
		return false
	}
	next()
})

router.afterEach((to, from) => {
	NProgress.done()
})

router.onError((error) => {
	NProgress.done()
	notification.error({
		message: '路由错误',
		description: error.message
	})
})

export default router
